// test143
(143 && 0);
